import { render, staticRenderFns } from "./SendTestEmailModal.vue?vue&type=template&id=6bb23cc2"
import script from "./SendTestEmailModal.vue?vue&type=script&lang=js"
export * from "./SendTestEmailModal.vue?vue&type=script&lang=js"
import style0 from "./SendTestEmailModal.vue?vue&type=style&index=0&id=6bb23cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports